<template>
  <v-chip v-if="item.reason.length >= 1" color="#EC547A" text-color="#FFFFFF">
    <template v-if="item.reason.length === 1">
      <span>
        {{ item.reason.find(el => !!el).title }}
      </span>
    </template>
    <template v-if="item.reason.length > 1">
      <v-menu>
        <template v-slot:activator="{ on: menu, attrs }">
          <div v-bind="attrs" v-on="{ ...menu }">
            Multiple
            <v-chip color="#FFFFFF" text-color="#EC547A" small>
              {{ item.reason.length }}
            </v-chip>
          </div>
        </template>
        <v-list v-if="item.reason.length > 1">
          <v-list-item v-for="(reason, index) in item.reason" :key="index">
            <v-list-item-title text-color="#FFFFFF">{{
              reason.title
            }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </template>
  </v-chip>
  <div v-else>
    OK
  </div>
</template>

<script>
export default {
  name: "Rules_Demo",
  props: {
    item: {
      type: Object,
      required: true
    }
  }
};
</script>

<style scoped></style>
